/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]:not(.checkbox-col) {\n  cursor: pointer; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/case/case.component.scss.shim.ngstyle.js.pre-build-optimizer.js